"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var PipStateEnum = Object.freeze({
  PIP_MODE_STATE_TRUE: 1,
  PIP_MODE_STATE_FALSE: 0,
  PIP_MODE_STATE_DISABLED: -1
});
var _default = exports.default = PipStateEnum;